import { useEffect } from 'react'

import { useAuth } from '@percent/workplace-giving/common/hooks'
import { config } from '@percent/workplace-giving/config/config'
import { getPartnerFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

type WpgSessionMessage = {
  type: 'WPG_SESSION'
  version: 1
  isLoggedIn: boolean
  partnerId: string | null
}

export function SessionBridge() {
  const { state } = useAuth()

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    // Only useful when embedded (e.g. in an iframe), but safe in all cases
    const partner = getPartnerFromAuthState(state)

    const message: WpgSessionMessage = {
      type: 'WPG_SESSION',
      version: 1,
      isLoggedIn: Boolean(partner),
      partnerId: partner?.id ?? null
    }

    const targets = config.allowedMessageOrigins?.length ? config.allowedMessageOrigins : ['*']

    targets.forEach(origin => {
      try {
        window.parent.postMessage(message, origin)
      } catch {
        // Intentionally ignore failures – bridge should never break the app
      }
    })
  }, [state])

  // No visible UI – this route exists solely to communicate auth state to a parent window.
  return null
}
